import React, { useState, useRef, useEffect } from 'react';
import searchIcon from '../../images/SearchIcon1.png';
import useLocaleStore from '../../store/localeStore';
import { t } from '../../i18n/translations';

const SearchComponent: React.FC<{
  searchKeyword: string;
  handleSearchInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  getThemes: any;
}> = ({ searchKeyword, handleSearchInputChange, getThemes }) => {
  useLocaleStore((state) => state.locale);
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const searchRef = useRef<HTMLDivElement>(null);

  const toggleSearch = () => {
    setIsSearchVisible(!isSearchVisible);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (searchRef.current && !searchRef.current.contains(event.target as Node)) {
        setIsSearchVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // White
   // White
   const isWhiteOrShade = (color: string): boolean => {
    const s = color.trim().toLowerCase();
  
    // 1) explicit white checks
    if (
      s === "white" ||
      s === "#fff" ||
      s === "#ffffff" ||
      s === "rgb(255,255,255)" ||
      s === "rgba(255,255,255,1)"
    ) {
      return true;
    }
  
    let r: number, g: number, b: number;
  
    // 2) hex formats
    if (s.startsWith("#")) {
      let hex = s.slice(1);
      if (hex.length === 3) {
        // expand `#abc` → `#aabbcc`
        hex = hex.split("").map(ch => ch + ch).join("");
      }
      if (hex.length !== 6 || !/^[0-9a-f]{6}$/i.test(hex)) {
        return false;
      }
      r = parseInt(hex.slice(0, 2), 16);
      g = parseInt(hex.slice(2, 4), 16);
      b = parseInt(hex.slice(4, 6), 16);
    }
    // 3) rgb/rgba formats
    else {
      const m = s.match(
        /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})(?:\s*,\s*[\d.]+)?\s*\)/
      );
      if (!m) return false;
      r = Number(m[1]);
      g = Number(m[2]);
      b = Number(m[3]);
    }
  
    // 4) threshold for "almost white"
    return r >= 235 && g >= 235 && b >= 235;
  };
  

  
  // Usage in JSX
  const borderColor = getThemes && isWhiteOrShade(getThemes.color1) ? getThemes.color2 : getThemes.color1;
  

  return (
    <div ref={searchRef} className="relative">
      <div
        onClick={toggleSearch}
        className="flex items-center cursor-pointer"
      >
        <img 
          src={searchIcon} 
          alt={t("search.alt")} 
          className="w-10 h-10 mr-2"
        />
        <span>{t("search.label")}</span>
      </div>
      {isSearchVisible && (
        <div className="op-full -left-16 -mt-10 w-64">
          <input
            type="text"
            id="searchProperty"
            className="py-2 px-3 w-full border-primarycolor border-2 rounded-md text-sm"
            placeholder={t("search.placeholder")}
            value={searchKeyword}
            onChange={handleSearchInputChange}
            style={{ borderColor }}
          />
        </div>
      )}
    </div>
  );
};

export default SearchComponent;